import React, { Fragment, memo } from 'react';

import { Box, Typography } from '@mui/material';
import GlobalityLabelCDS from '@sharedCR/coreDesignSystem/GlobalityLabelCDS';
import PropTypes from 'prop-types';

import { getConditionalObject } from 'utils/data';

const FormAutocompleteOption = ({ option, optionText, multiple }) => {
  const Wrapper = multiple ? Box : Fragment;

  return (
    <Wrapper {...getConditionalObject(multiple, { className: 'w-full flex justify-between mr-8' })}>
      <Typography data-truncated className="truncate" variant="regular16">
        {optionText}
      </Typography>
      {!option.isWithoutTag && <GlobalityLabelCDS isGlobal={option.isGlobal} />}
    </Wrapper>
  );
};

FormAutocompleteOption.propTypes = {
  option: PropTypes.object.isRequired,
  optionText: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
};

export default memo(FormAutocompleteOption);
